import { render, staticRenderFns } from "./FeaturedProjects.vue?vue&type=template&id=d0f6d4e2"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports